if(!customElements.get('variant-popup')){
    class VariantPopup extends HTMLElement {
        constructor(){
            super();

            // close popup
            this.querySelectorAll('[data-close]').forEach(item => {
                item.addEventListener('click', this.closePopup.bind(this));
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter' || e.key === ' '){
                        e.preventDefault();
                        this.closePopup();
                    }
                });
            });

            this.popupStyle = this.dataset.style;

            if(this.popupStyle !== 'full'){
                this.addEventListener('click', e => {
                    if(e.target === this) this.closePopup();
                });
            }
           
            this.addEventListener('keyup', e => {
                if(e.code && e.code.toUpperCase() === 'ESCAPE') this.closePopup();
            });
            
            this.contentWrapper = this.querySelector('.variant-popup__content');
            this.popupInner = this.querySelector('.popup__inner');
        }

        connectedCallback(){
            this.onVariantPopupUnsubscriber = PubSub.subscribe(PubSub.events.onVariantPopup, this.handleProductUpdate.bind(this));
            this.onVariantPopupSubmittedUnsubscriber = PubSub.subscribe(PubSub.events.onSubmitProductForm, this.closePopup.bind(this));
        }

        disconnectedCallback(){
            if(this.onVariantPopupUnsubscriber && typeof this.onVariantPopupUnsubscriber === 'function'){
                this.onVariantPopupUnsubscriber();
            }
            if(this.onVariantPopupSubmittedUnsubscriber && typeof this.onVariantPopupSubmittedUnsubscriber === 'function'){
                this.onVariantPopupSubmittedUnsubscriber();
            }
        }

        handleProductUpdate({ data: { productUrl, productId, selectedOptionValues } }){
            this.pendingTriggerElement = document.activeElement;
            this.pendingRequestUrl = productUrl;

            const url = productUrl || this.pendingRequestUrl;

            this.renderContent({
                requestUrl: this.buildRequestUrlWithParams(url, selectedOptionValues),
                targetId: productId,
                callback: this.updateVariantPopup()
            });
        }

        renderContent({ requestUrl, targetId, callback }){
            this.abortController?.abort();
            this.abortController = new AbortController();

            fetch(requestUrl, { signal: this.abortController.signal })
                .then(res => res.text())
                .then(resText => {
                    this.pendingRequestUrl = null;
                    const html = new DOMParser().parseFromString(resText, 'text/html');
                    callback(html);
                })
                .catch(error => {
                    if(error.name === 'AbortError') {
                        console.log('Fetch aborted by user');
                    }else{
                        console.error(error);
                    }
                });
        }

        updateVariantPopup(){
            return (html) => {
                if(html.querySelector('.product-content')){
                    html.querySelector('.product-content').style.maxWidth = !html.querySelector('.product-media')? '100%' : 'var(--content-width)';
                }

                const scripts = html.querySelectorAll('script');
                const newScripts = [];
                scripts.forEach(script => {
                    if(script.getAttribute('type') !== 'application.json'){
                        newScripts.push(script);
                        script.remove();
                    }
                });

                this.contentWrapper.innerHTML = html.querySelector('.variant-popup__content').innerHTML;

                newScripts.forEach(script => {
                    const newScript = document.createElement('script');
                    if(script.src) {
                        newScript.src = script.src;
                    }else{
                        newScript.textContent = script.textContent;
                    }

                    Array.from(script.attributes).forEach(attr => {
                        newScript.setAttribute(attr.name, attr.value);
                    });

                    this.contentWrapper.append(newScript);
                });

                this.openPopup();
            }
        }

        buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false){
            const params = [];

            !shouldFetchFullPage && params.push(`section_id=variant-popup`);

            if(optionValues.length) {
                params.push(`option_values=${optionValues.join(',')}`);
            }

            if(url.includes('?')) return `${url}&${params.join('&')}`;

            return `${url}?${params.join('&')}`;
        }

        openPopup(){
            this.previouslyFocusedElement = this.pendingTriggerElement || document.activeElement;
            this.pendingTriggerElement = null;

            this.setAttribute('data-hidden', 'false');
            this.removeAttribute('inert');

            setTimeout(() => {
                this.popupInner.scrollTo({ top: 0 });
                this.popupInner.setAttribute('data-hidden', 'false');
            }, 300);

            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';

            this.querySelector('product-media')?.classList.remove('opacity-0');

            FocusTrap.activate(this);
            this.addFocus();

            PubSub.publish(PubSub.events.cartClose, {});
        }

        addFocus(){
            setTimeout(() => {
                const tabableElements = this.querySelectorAll('a, button');
                if(tabableElements.length > 0){
                    tabableElements[0].focus();
                }
            }, 100);
        }

        closePopup(){
            FocusTrap.deactivate(this);

            this.setAttribute('data-hidden', 'true');
            this.setAttribute('inert', '');

            this.popupInner.setAttribute('data-hidden', 'true');

            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';

            if(this.previouslyFocusedElement){
                this.previouslyFocusedElement.focus();
            }
        }
    }

    customElements.define('variant-popup', VariantPopup);
}